import React from 'react';
import { useAppSelector } from "src/store/hooks";
import { selectUserById } from "src/store/community/usersSlice";
import { selectPostById } from "src/store/community/postsSlice";

import { RightSidebar } from "src/pages/_partials/Layout";
import Meta from "src/pages/community/Users/_partials/_Meta";
import CategoryMeta from "src/componets/Meta";
import { EntityId } from "@reduxjs/toolkit";
import { selectCategoryById } from "src/store/community/categoriesSlice";

const _SidebarShow = ({ id }: { id: EntityId | undefined }) => {
  const post = useAppSelector(state => id ? selectPostById(state, id) : undefined);
  const user = useAppSelector(state => post?.user_id ? selectUserById(state, post?.user_id) : undefined);
  const category = useAppSelector(state => post?.category_id ? selectCategoryById(state, post?.category_id) : undefined);

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>
      <hr className="v-divider" />

      {user && <h6 className="v-content-label o-sm">User</h6>}
      {<Meta user={user} />}

      {<h6 className="v-content-label o-sm">Category</h6>}
      {category && <CategoryMeta title={category.name} avatar={category.thumbnail_url} />}
    </RightSidebar>
  )
}

export default _SidebarShow;
